export default function initTrackingBanner() {
    const banner = document.getElementById('tracking-banner');
    const button = document.getElementById('tracking-button');

    if (!banner || !button) return;

    const cookieName = 'tracking-confirmation';
    const cookieOptions = {
        expires: 5184000, // 60 days in seconds
    };

    const consent = Cookies.get(cookieName);
    if (consent) {
        return;
    }

    banner.classList.remove('hidden');

    button.addEventListener('click', (e) => {
        e.preventDefault();

        const consentData = JSON.stringify({
            dismissedAt: new Date().toISOString(),
        });

        Cookies.set(cookieName, consentData, cookieOptions);

        // Hide banner after saving
        banner.classList.add('hidden');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initTrackingBanner();
});
